import { typeSafeObjectKeys } from './typeSafeObjectKeys'

export function typeSafeObjectValues<T extends Object>(
  obj: T
): Array<T[keyof T]> {
  return typeSafeObjectKeys(obj).map(k => obj[k])
}
